import { z } from 'zod';
import { StatusTypeSchema } from '../enums/status.js';
import { authDetailsSchema, authSchema } from './auth.js';

export const subjectAutocompleteDataSchema = z.object({
  endpoint: z.string(),
  queryParam: z.string().optional(),
  auth: authSchema,
  required: z.boolean(),
});
export type SubjectAutocompleteData = z.infer<typeof subjectAutocompleteDataSchema>;

// Schema with detailed auth data
export const subjectAutocompleteDetailsSchema = z.object({
  endpoint: z.string(),
  queryParam: z.string().optional(),
  auth: authDetailsSchema,
  required: z.boolean(),
});
export type SubjectAutocompleteDetails = z.infer<typeof subjectAutocompleteDetailsSchema>;

export const chatContextTableItemSchema = z.object({
  id: z.coerce.number(),
  identifier: z.string(),
  name: z.string(),
  status: StatusTypeSchema,
  primaryAgent: z.object({
    id: z.coerce.number(),
    name: z.string(),
  }),
  applications: z.array(z.object({
    id: z.coerce.number(),
    name: z.string(),
  })),
  metadata: z.object({
    applications: z.number(),
  }),
});
export type ChatContextTableItem = z.infer<typeof chatContextTableItemSchema>;


export const chatContextDataSchema = z.object({
  chatNameTemplate: z.string(),
  createdOn: z.coerce.date(),
  id: z.coerce.number(),
  identifier: z.string(),
  name: z.string(),
  status: StatusTypeSchema,
  primaryAgent: z.object({
    id: z.coerce.number(),
    identifier: z.string(),
    name: z.string(),
  }),
  initialMessage: z.string().nullable(),
  questions: z.array(z.string()),
  additionalAgentContext: z.record(z.string(), z.unknown()),
  subjectAutocomplete: subjectAutocompleteDataSchema.nullable(),
  showLandingCardsOnNewChat: z.boolean().prefault(false),
});
export type ChatContextData = z.infer<typeof chatContextDataSchema>;


export const chatContextDetailsSchema = z.object({
  chatNameTemplate: z.string(),
  createdOn: z.coerce.date(),
  id: z.coerce.number(),
  identifier: z.string(),
  name: z.string(),
  status: StatusTypeSchema,
  primaryAgent: z.object({
    id: z.coerce.number(),
    identifier: z.string(),
    name: z.string(),
  }),
  initialMessage: z.string().nullable(),
  questions: z.array(z.string()),
  additionalAgentContext: z.record(z.string(), z.unknown()),
  subjectAutocomplete: subjectAutocompleteDetailsSchema.nullable(),
  showLandingCardsOnNewChat: z.boolean().prefault(false),
});
export type ChatContextDetails = z.infer<typeof chatContextDetailsSchema>;